import React, { useEffect, useState } from 'react'
import TextareaAutosize from 'react-textarea-autosize'
import styles from './CustomTextareaAutosize.module.scss'

export default function CustomTextareaAutosize({ clearable = false, disabled, value, onChange, ...props }) {
  const [internalDisabled, setInternalDisabled] = useState(disabled)

  useEffect(() => {
    setInternalDisabled(disabled)
  }, [disabled])

  const handleClear = () => {
    if (onChange) {
      const syntheticEvent = {
        target: { value: '' },
        currentTarget: { value: '' },
      }
      onChange(syntheticEvent)
    }
    setInternalDisabled(false)
  }

  const showClearButton = clearable && internalDisabled && disabled

  return (
    <div className={styles.container}>
      <TextareaAutosize
        {...props}
        value={value}
        onChange={onChange}
        disabled={internalDisabled && disabled}
        className={`${props.className || ''} ${showClearButton ? styles.withClearButton : ''}`}
        style={{
          ...props.style,
          paddingRight: showClearButton ? '30px' : props.style?.paddingRight || '12px',
        }}
      />
      {showClearButton && (
        <button
          type="button"
          onClick={handleClear}
          className={styles.clearButton}
          title="Clear text"
        >
          ×
        </button>
      )}
    </div>
  )
}
